/**
 * Display host for an external link target.
 *
 * A link-blog item (Daring Fireball, HN link posts, etc.) carries a
 * `linked_url` pointing at the external page it links to. The reader shows that
 * destination as a bare hostname — `www.` stripped, no scheme, no path. This is
 * the single owner of that derivation, so the rule (and the guard against a
 * malformed `linked_url`) lives in one place instead of being re-spelled at
 * every render site.
 *
 * Returns `''` when the value is missing or is not a parseable absolute URL, so
 * a bad `linked_url` degrades to no host text rather than throwing `new URL(…)`
 * mid-render and taking down the whole story row.
 *
 * This is the rule owner across clients: iOS mirrors it in
 * `ios/Kingfisher/LinkHost.swift` and Android in `linkHost()` in
 * `data/api/Models.kt`; `backend/tests/test_mirror_parity.py` pins all three.
 * Admin surfaces (StoryDetailPage's "Links To" row and its mobile twins)
 * deliberately show the full URL and don't use this rule.
 */
export function linkHost(value: string | null | undefined): string {
  if (!value) return '';
  try {
    return new URL(value).hostname.replace(/^www\./, '');
  } catch {
    return '';
  }
}
